import { createContext } from 'react';

const trabajoContext = createContext();

export default trabajoContext;
